import { render, staticRenderFns } from "./ArchivioSpedizioniDetails.vue?vue&type=template&id=0ce6b9ef&scoped=true"
import script from "./ArchivioSpedizioniDetails.vue?vue&type=script&lang=js"
export * from "./ArchivioSpedizioniDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce6b9ef",
  null
  
)

export default component.exports